<template>
  <li
    v-if="checkPermission(item.permission)"
    class="nav-item"
    :class="{
      'active': isActive,
      'disabled': item.disabled,
      'fw-semibold': isActive,
      'fw-medium': !isActive
    }"
  >
    <b-link
      v-bind="linkProps"
      class="d-flex align-items-center"
    >
      <component
        :is="getIconComponent(item.icon)"
        class="mr-1"
        :size="14"
        :color="getIconColor(item.icon, isActive)"
      />
      <span class="menu-title text-truncate fs-14">{{ t(item.title) }}</span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
  </li>
</template>

<script>
import { useUtils as useAclUtils } from '@core/libs/acl'
import { BLink, BBadge } from 'bootstrap-vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import { mapGetters } from 'vuex'
import * as LucideIcons from 'lucide-vue'
import useVerticalNavMenuLink from './useVerticalNavMenuLink'
import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink'

export default {
  components: {
    BLink,
    BBadge,
  },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(props.item)
    const { t } = useI18nUtils()
    const { canViewVerticalNavMenuLink } = useAclUtils()

    return {
      isActive,
      linkProps,
      updateIsActive,

      // ACL
      canViewVerticalNavMenuLink,

      // i18n
      t,
    }
  },
  computed: {
    ...mapGetters(['permissions']),
  },
  methods: {
    // eslint-disable-next-line consistent-return,no-unused-vars
    checkPermission(routePermissions) {
      if (this.permissions && routePermissions) {
        return this.permissions.some(i => routePermissions.includes(i))
      }
      return true
    },
    getIconComponent(iconName) {
      return LucideIcons[iconName] || LucideIcons.CircleIcon
    },

    getIconColor(iconName, isActive) {
      const iconComponent = LucideIcons[iconName] || LucideIcons.CircleIcon
      if (
        iconComponent === LucideIcons.CircleIcon
    || iconComponent === LucideIcons.ComponentIcon
      ) {
        return isActive ? 'var(--primary)' : '#434343'
      }
      return isActive ? 'White' : '#434343'
    },
  },
}
</script>

<style>
.fs-14 {
  font-size: 14px;
}
.fw-medium {
  font-weight: 500;
}

.fw-semibold {
  font-weight: 600;
}
</style>
